/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import MigrateContactsButton from "components/Contacts/MigrateContactsButton";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Input,
  Button,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { useFirebase } from "model/context/firebase.context";
import { COLLECTIONS } from "model/constants";

function AdminSettings() {
  const { app } = useFirebase(); // Make sure your context returns { app, db } or at least app
  const db = getDatabase(app);

  const [projectStatusInput, setProjectStatusInput] = useState("");
  const [projectStatuses, setProjectStatuses] = useState([]);

  const [salesPersonInput, setSalesPersonInput] = useState("");
  const [salesPersons, setSalesPersons] = useState([]);

  useEffect(() => {
    const statusRef = ref(db, `${COLLECTIONS.settings}/ProjectStatus`);
    onValue(statusRef, (snapshot) => {
      const data = snapshot.val();
      setProjectStatuses(Array.isArray(data) ? data : []);
    });

    const salesRef = ref(db, `${COLLECTIONS.settings}/SalesPersons`);
    onValue(salesRef, (snapshot) => {
      const data = snapshot.val();
      setSalesPersons(Array.isArray(data) ? data : []);
    });
  }, [db]);

  const addItemToArray = (path, newItem, currentArray) => {
    const updated = [...currentArray, newItem];
    set(ref(db, path), updated);
  };

  const deleteItemFromArray = (path, index, currentArray) => {
    const updated = currentArray.filter((_, i) => i !== index);
    set(ref(db, path), updated);
  };

  return (
    <Container fluid>
      <Row>
        <Col className="mt-5" xs="12">
          <Card>
            <CardHeader>Contacts</CardHeader>
            <CardBody className="d-flex gap-2 align-items-center justify-content-between">
              <div>
                <h3>Migrate contacts</h3>
                <p>
                  Migrate clients and leads contacts to accept multiple
                  contacts.
                </p>
              </div>
              <MigrateContactsButton />
            </CardBody>

            {/* Project Status Section */}
            <CardBody>
              <h3>Project Status</h3>
              <div className="d-flex gap-2 mb-3">
                <Input
                  value={projectStatusInput}
                  onChange={(e) => setProjectStatusInput(e.target.value)}
                  placeholder="Add new status"
                />
                <Button
                  color="primary"
                  onClick={() => {
                    if (
                      projectStatusInput &&
                      !projectStatuses.includes(projectStatusInput)
                    ) {
                      addItemToArray(
                        `${COLLECTIONS.settings}/ProjectStatus`,
                        projectStatusInput,
                        projectStatuses
                      );
                      setProjectStatusInput("");
                    }
                  }}
                >
                  +
                </Button>
              </div>
              <ListGroup>
                {projectStatuses.map((status, index) => (
                  <ListGroupItem
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    {status}
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() =>
                        deleteItemFromArray(
                          `${COLLECTIONS.settings}/ProjectStatus`,
                          index,
                          projectStatuses
                        )
                      }
                    >
                      Delete
                    </Button>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </CardBody>

            {/* Sales Person Section */}
            <CardBody>
              <h3>Sales Person</h3>
              <div className="d-flex gap-2 mb-3">
                <Input
                  value={salesPersonInput}
                  onChange={(e) => setSalesPersonInput(e.target.value)}
                  placeholder="Add new salesperson"
                />
                <Button
                  color="primary"
                  onClick={() => {
                    if (
                      salesPersonInput &&
                      !salesPersons.includes(salesPersonInput)
                    ) {
                      addItemToArray(
                        `${COLLECTIONS.settings}/SalesPersons`,
                        salesPersonInput,
                        salesPersons
                      );
                      setSalesPersonInput("");
                    }
                  }}
                >
                  +
                </Button>
              </div>
              <ListGroup>
                {salesPersons.map((person, index) => (
                  <ListGroupItem
                    key={index}
                    className="d-flex justify-content-between align-items-center"
                  >
                    {person}
                    <Button
                      color="danger"
                      size="sm"
                      onClick={() =>
                        deleteItemFromArray(
                          `${COLLECTIONS.settings}/SalesPersons`,
                          index,
                          salesPersons
                        )
                      }
                    >
                      Delete
                    </Button>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default AdminSettings;
